// Every word the maid's own screens say, in the three languages this shop's
// staff read: Thai, English and Burmese. The printed receipt is deliberately
// absent - that paper is handed to the customer, so it stays Thai whatever
// language the maid happens to be working in.
//
// These keys are merged into the app dictionary in utils/i18n.js. A key a
// language is missing falls back to Thai rather than showing the bare key.

const maidTranslations = {
  th: {
    "maid.title": "แม่บ้าน",
    "maid.history": "ประวัติ",
    "maid.branch": "สาขา",
    "maid.branch_code": "รหัสสาขา {code}",
    "maid.login_subtitle": "ระบบจัดการงานสำหรับพนักงาน",
    "maid.login_submit": "เข้าสู่ระบบ",

    // Stage strip
    "maid.stage.drop": "DROP ผ้า",
    "maid.stage.wash": "ซัก",
    "maid.stage.dry": "อบ",
    "maid.stage.finish": "เสร็จสิ้น",
    "maid.stage.pickup": "ส่งผ้า",

    // Queues and figures
    "maid.queue": "ลำดับคิว",
    "maid.basket_queue": "คิวตะกร้า",
    "maid.basket_queue_laundry": "คิวตะกร้าผ้า",
    "maid.pickup_queue": "คิวรับผ้า",
    "maid.machine_number": "หมายเลขเครื่อง",
    "maid.machine_short": "เครื่อง",
    "maid.customer": "ลูกค้า",
    "maid.phone": "เบอร์โทร",
    "maid.credit_total": "จำนวนที่มี",
    "maid.credit_used": "ใช้ไป",
    "maid.credit_left": "คงเหลือ",
    "maid.amount_total": "จำนวนเงินทั้งหมด",
    "maid.amount_used": "จำนวนเงินที่ใช้",
    "maid.amount_left": "จำนวนเงินคงเหลือ",
    "maid.all_items": "รายการทั้งหมด",
    "maid.note": "*หมายเหตุ",
    "maid.notes_label": "หมายเหตุ:",
    "maid.order_detail": "รายละเอียดคำสั่ง",
    "maid.grand_total": "ยอดรวม",
    "maid.no_orders": "ไม่มีรายการในขณะนี้",
    "maid.new_basket_alert": "มีตะกร้าใหม่เข้ามา!",
    "maid.view": "ดู",
    "maid.uploading_photo": "กำลังอัปโหลดรูป...",
    "maid.proof": "หลักฐาน",
    "maid.close_detail": "ปิดรายละเอียด",

    // Services
    "maid.service.wash": "ซัก {size}",
    "maid.service.dry": "อบ {size}",
    "maid.service.washer": "เครื่องซัก {size}",
    "maid.service.dryer": "เครื่องอบ {size}",
    "maid.service.detergent": "น้ำยาซักผ้า {count}",
    "maid.service.softener": "น้ำยาปรับผ้านุ่ม {count}",
    "maid.service.extra_dry": "เพิ่มเวลาอบ {minutes} นาที",
    "maid.water.cold": "น้ำเย็น",
    "maid.water.warm": "น้ำอุ่น",
    "maid.water.hot": "น้ำร้อน",

    // Buttons
    "maid.btn.wash": "ซัก",
    "maid.btn.dry": "อบ",
    "maid.btn.backup": "สำรอง",
    "maid.btn.backup_in": "สำรองได้ในอีก {seconds} วิ",
    "maid.btn.confirm": "ยืนยัน",
    "maid.btn.deliver": "ส่งผ้า",
    "maid.btn.receive": "รับผ้า",
    "maid.btn.close": "ปิด",
    "maid.btn.cancel": "ยกเลิก",
    "maid.btn.ok": "ตกลง",
    "maid.btn.yes": "ใช่",
    "maid.btn.no": "ไม่",
    "maid.btn.save_order": "บันทึกรายการ",
    "maid.btn.saving": "กำลังบันทึก...",
    "maid.btn.processing": "กำลังดำเนินการ...",
    "maid.btn.printing": "กำลังพิมพ์...",
    "maid.btn.start_work": "เริ่มทำงาน",
    "maid.btn.finish": "เสร็จสิ้น",
    "maid.btn.ready_to_deliver": "พร้อมส่งผ้า",
    "maid.btn.detergent_photo": "ถ่ายภาพน้ำยา",
    "maid.btn.detergent_photo_again": "ถ่ายภาพน้ำยาใหม่",
    "maid.btn.basket_photo": "ถ่ายรูปตะกร้า",
    "maid.btn.basket_photo_again": "ถ่ายรูปตะกร้าใหม่",
    "maid.btn.scan_washer": "สแกน QR เครื่องซัก",
    "maid.btn.scan_dryer": "สแกน QR เครื่องอบ",
    "maid.btn.back_home": "กลับไปหน้า Home",
    "maid.btn.print_new_slip": "พิมพ์ใบรายการใหม่",
    "maid.btn.print_new_receipt": "พิมพ์ใบเสร็จรับเงินใหม่",

    // Toasts and prompts
    "maid.toast.confirmed_ready": "ยืนยันเสร็จสิ้น พร้อมส่งผ้า",
    "maid.toast.delivered": "ส่งผ้าเรียบร้อย",
    "maid.toast.detergent_saved": "บันทึกรูปน้ำยาแล้ว",
    "maid.toast.detergent_save_failed": "บันทึกรูปน้ำยาไม่สำเร็จ",
    "maid.toast.order_saved": "บันทึกรายการแล้ว",
    "maid.toast.order_save_failed": "บันทึกรายการไม่สำเร็จ",
    "maid.toast.receive_failed": "รับผ้าไม่สำเร็จ",
    "maid.toast.basket_queue_required": "กรุณากรอกคิวตะกร้า",
    "maid.toast.basket_queue_before_print": "กรุณากรอกคิวตะกร้าก่อนพิมพ์",
    "maid.toast.basket_queue_save_failed": "บันทึกคิวตะกร้าไม่สำเร็จ",
    "maid.toast.no_printer": "ไม่พบเครื่องพิมพ์ Bluetooth",
    "maid.toast.pickup_queue_required": "กรุณากรอกคิวรับผ้าก่อนรับผ้า",
    "maid.toast.basket_photo_required": "กรุณาถ่ายรูปตะกร้าก่อนรับผ้า",
    "maid.toast.photo_required": "กรุณาถ่ายรูปหรือเลือกรูปภาพ",
    "maid.toast.error": "เกิดข้อผิดพลาด",
    "maid.toast.error_retry": "เกิดข้อผิดพลาด กรุณาลองใหม่",
    "maid.toast.error_retry_long": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    "maid.no_order_found": "ไม่พบข้อมูลคำสั่ง",
    "maid.basket_photo_hint": "ถ่ายรูปตะกร้าก่อนรับผ้า",
    "maid.cancel_title": "ยืนยันการยกเลิก",
    "maid.cancel_order_question": "คุณต้องการยกเลิกคำสั่งนี้หรือไม่?",
    "maid.cancel_job_question": "คุณต้องการยกเลิกการรับงานนี้หรือไม่?",

    // Photo modal
    "maid.photo.completed_title": "ถ่ายรูปผ้าที่เสร็จแล้ว",
    "maid.photo.basket_title": "ถ่ายรูปตะกร้า",
    "maid.photo.detergent_title": "ถ่ายรูปยืนยันการใช้น้ำยา",
    "maid.photo.retake": "ถ่ายใหม่",
    "maid.photo.camera": "กล้อง",
    "maid.photo.gallery": "แกลลอรี่",

    // Scan
    "maid.scan.washer": "เครื่องซัก",
    "maid.scan.dryer": "เครื่องอบ",
    "maid.scan.allow_camera": "กรุณาอนุญาตการใช้กล้อง",
    "maid.scan.invalid_qr": "QR Code ไม่ถูกต้อง",
    "maid.scan.machine_busy": "{machine}นี้ไม่ว่าง หรือไม่ใช่ประเภทที่ต้องการ",
    "maid.scan.wrong_size": "ออร์เดอร์นี้ต้องใช้{machine} {size} kg.",
    "maid.scan.start_failed": "ไม่สามารถสั่งเครื่องได้ กรุณาลองใหม่",
    "maid.scan.assign_failed": "ไม่สามารถกำหนดเครื่องได้",
    "maid.scan.assigned_washer": "กำหนดเครื่องซัก #{number} เรียบร้อย",
    "maid.scan.assigned_dryer": "กำหนดเครื่องอบ #{number} เรียบร้อย",
    "maid.scan.no_machine_free": "ไม่มีเครื่องว่าง",
    "maid.scan.camera_failed": "ไม่สามารถเปิดกล้องได้",
    "maid.scan.pick_free_machine": "เลือก{machine}{size}ที่ว่าง",
    "maid.scan.none_free": "ไม่มี{machine}{size}ว่างในขณะนี้",
    "maid.scan.refresh": "รีเฟรช",
    "maid.scan.pick_from_list": "เลือกเครื่องจากรายการ",
    "maid.scan.pick_from_list_hint": "กรุณาเลือกเครื่องจากรายการด้านล่าง",
    "maid.scan.machines_free": "มีเครื่องว่าง {count} เครื่อง",
    "maid.scan.checking_camera": "กำลังตรวจสอบกล้อง...",
    "maid.scan.assigning": "กำลังกำหนดเครื่อง...",
    "maid.scan.scan_qr_on": "สแกน QR Code บน{machine}",
    "maid.scan.scan_qr_hint": "ที่ต้องการใช้งาน",

    // History
    "maid.history.title": "ประวัติการใช้งาน",
    "maid.history.search_title": "ค้นหาประวัติการใช้งาน",
    "maid.history.search_placeholder": "ชื่อลูกค้า เบอร์โทร หรือ ลำดับคิว คิวตะกร้า",
    "maid.history.sort_by": "เรียงตาม",
    "maid.history.sort_date": "วันที่",
    "maid.history.sort_queue": "ลำดับคิว",
    "maid.history.sort_basket": "คิวตะกร้า",
    "maid.history.old_to_new": "เก่า → ใหม่",
    "maid.history.new_to_old": "ใหม่ → เก่า",
    "maid.history.low_to_high": "น้อย → มาก",
    "maid.history.high_to_low": "มาก → น้อย",
    "maid.history.empty": "ยังไม่มีประวัติการใช้งาน",
    "maid.history.not_found": "ไม่พบประวัติที่ค้นหา",
    "maid.history.back": "‹ กลับประวัติ",
    "maid.history.photo_basket": "รูปตะกร้า",
    "maid.history.photo_detergent": "รูปน้ำยา",
    "maid.history.photo_done": "รูปเสร็จสิ้น",
    "maid.history.photo_delivery": "รูปส่งผ้า",
    "maid.history.photo_completed": "รูปผ้าที่ทำเสร็จ",
    "maid.history.receipt": "ใบเสร็จรับเงิน",

    // Countdown
    "maid.timer.not_started": "{label}: ยังไม่เริ่ม",
    "maid.timer.done": "เสร็จแล้ว!",
    "maid.timer.started_at": "เริ่ม:",
    "maid.timer.minutes": "{minutes} นาที",

    // Bill lines the maid reads on screen (the printed receipt stays Thai)
    "maid.services": "การใช้บริการ",
    "maid.discounts": "ส่วนลด",
    "maid.service_fee": "ค่าบริการ Drop&Go",
    "maid.discount.service": "ส่วนลดค่าบริการ Drop&Go",
    "maid.discount.status_gold": "ส่วนลดสถานะ Gold",
    "maid.discount.points": "ส่วนลดคะแนนสะสม",
    "maid.discount.coupon": "ส่วนลดคูปอง",
    "maid.payment": "ชำระเงิน",

    // Tabs on the dashboard
    "maid.tab.new_basket": "ตะกร้าใหม่",
    "maid.tab.preparing": "กำลังเตรียม",
    "maid.tab.working": "กำลังทำงาน",
    "maid.tab.completed": "เสร็จสิ้น",
    "maid.tab.pickup": "ส่งผ้า",

    // Printing
    "maid.print.receipt": "พิมพ์ใบเสร็จ",
    "maid.print.basket_slip": "พิมพ์ใบติดตะกร้าผ้า",
    "maid.print.all": "พิมพ์ทั้งหมด",
    "maid.print.hint_all": "ตรวจทั้งสองใบ แล้วกด “พิมพ์ทั้งหมด” อีกครั้งเพื่อพิมพ์",
    "maid.print.hint_basket": "ตรวจใบติดตะกร้าผ้า แล้วกด “พิมพ์ใบติดตะกร้าผ้า” อีกครั้งเพื่อพิมพ์",
    "maid.print.hint_customer": "ตรวจใบเสร็จ แล้วกด “พิมพ์ใบเสร็จ” อีกครั้งเพื่อพิมพ์",

  },

  en: {
    "maid.title": "Staff",
    "maid.history": "History",
    "maid.branch": "Branch",
    "maid.branch_code": "Branch code {code}",
    "maid.login_subtitle": "Job management system for staff",
    "maid.login_submit": "Sign in",

    "maid.stage.drop": "DROP",
    "maid.stage.wash": "Wash",
    "maid.stage.dry": "Dry",
    "maid.stage.finish": "Done",
    "maid.stage.pickup": "Hand over",

    "maid.queue": "Queue no.",
    "maid.basket_queue": "Basket no.",
    "maid.basket_queue_laundry": "Laundry basket no.",
    "maid.pickup_queue": "Pickup no.",
    "maid.machine_number": "Machine number",
    "maid.machine_short": "Machine",
    "maid.customer": "Customer",
    "maid.phone": "Phone",
    "maid.credit_total": "Credit",
    "maid.credit_used": "Used",
    "maid.credit_left": "Remaining",
    "maid.amount_total": "Total amount",
    "maid.amount_used": "Amount used",
    "maid.amount_left": "Amount remaining",
    "maid.all_items": "All items",
    "maid.note": "*Note",
    "maid.notes_label": "Note:",
    "maid.order_detail": "Order details",
    "maid.grand_total": "Total",
    "maid.no_orders": "No orders right now",
    "maid.new_basket_alert": "A new basket has arrived!",
    "maid.view": "View",
    "maid.uploading_photo": "Uploading photo...",
    "maid.proof": "Proof",
    "maid.close_detail": "Close details",

    "maid.service.wash": "Wash {size}",
    "maid.service.dry": "Dry {size}",
    "maid.service.washer": "Washer {size}",
    "maid.service.dryer": "Dryer {size}",
    "maid.service.detergent": "Detergent {count}",
    "maid.service.softener": "Softener {count}",
    "maid.service.extra_dry": "Extra drying {minutes} min",
    "maid.water.cold": "Cold water",
    "maid.water.warm": "Warm water",
    "maid.water.hot": "Hot water",

    "maid.btn.wash": "Wash",
    "maid.btn.dry": "Dry",
    "maid.btn.backup": "Backup",
    "maid.btn.backup_in": "Backup in {seconds}s",
    "maid.btn.confirm": "Confirm",
    "maid.btn.deliver": "Hand over",
    "maid.btn.receive": "Receive",
    "maid.btn.close": "Close",
    "maid.btn.cancel": "Cancel",
    "maid.btn.ok": "OK",
    "maid.btn.yes": "Yes",
    "maid.btn.no": "No",
    "maid.btn.save_order": "Save order",
    "maid.btn.saving": "Saving...",
    "maid.btn.processing": "Working...",
    "maid.btn.printing": "Printing...",
    "maid.btn.start_work": "Start work",
    "maid.btn.finish": "Done",
    "maid.btn.ready_to_deliver": "Ready to hand over",
    "maid.btn.detergent_photo": "Photograph detergent",
    "maid.btn.detergent_photo_again": "Retake detergent photo",
    "maid.btn.basket_photo": "Photograph basket",
    "maid.btn.basket_photo_again": "Retake basket photo",
    "maid.btn.scan_washer": "Scan washer QR",
    "maid.btn.scan_dryer": "Scan dryer QR",
    "maid.btn.back_home": "Back to Home",
    "maid.btn.print_new_slip": "Print new slip",
    "maid.btn.print_new_receipt": "Print new receipt",

    "maid.toast.confirmed_ready": "Confirmed, ready to hand over",
    "maid.toast.delivered": "Handed over",
    "maid.toast.detergent_saved": "Detergent photo saved",
    "maid.toast.detergent_save_failed": "Could not save the detergent photo",
    "maid.toast.order_saved": "Order saved",
    "maid.toast.order_save_failed": "Could not save the order",
    "maid.toast.receive_failed": "Could not receive the laundry",
    "maid.toast.basket_queue_required": "Please enter the basket number",
    "maid.toast.basket_queue_before_print":
      "Enter the basket number before printing",
    "maid.toast.basket_queue_save_failed": "Could not save the basket number",
    "maid.toast.no_printer": "No Bluetooth printer found",
    "maid.toast.pickup_queue_required":
      "Enter the pickup number before receiving",
    "maid.toast.basket_photo_required":
      "Photograph the basket before receiving",
    "maid.toast.photo_required": "Please take or choose a photo",
    "maid.toast.error": "Something went wrong",
    "maid.toast.error_retry": "Something went wrong, please try again",
    "maid.toast.error_retry_long": "Something went wrong, please try again",
    "maid.no_order_found": "Order not found",
    "maid.basket_photo_hint": "Photograph the basket before receiving",
    "maid.cancel_title": "Confirm cancellation",
    "maid.cancel_order_question": "Cancel this order?",
    "maid.cancel_job_question": "Cancel taking this job?",

    "maid.photo.completed_title": "Photograph the finished laundry",
    "maid.photo.basket_title": "Photograph the basket",
    "maid.photo.detergent_title": "Photograph the detergent used",
    "maid.photo.retake": "Retake",
    "maid.photo.camera": "Camera",
    "maid.photo.gallery": "Gallery",

    "maid.scan.washer": "washer",
    "maid.scan.dryer": "dryer",
    "maid.scan.allow_camera": "Please allow camera access",
    "maid.scan.invalid_qr": "Invalid QR code",
    "maid.scan.machine_busy": "This {machine} is busy or the wrong type",
    "maid.scan.wrong_size": "This order needs a {size} kg. {machine}",
    "maid.scan.start_failed":
      "Could not command the machine, please try again",
    "maid.scan.assign_failed": "Could not assign the machine",
    "maid.scan.assigned_washer": "Washer #{number} assigned",
    "maid.scan.assigned_dryer": "Dryer #{number} assigned",
    "maid.scan.no_machine_free": "No machine free",
    "maid.scan.camera_failed": "Could not open the camera",
    "maid.scan.pick_free_machine": "Choose a free {machine}{size}",
    "maid.scan.none_free": "No {machine}{size} free right now",
    "maid.scan.refresh": "Refresh",
    "maid.scan.pick_from_list": "Choose from the list",
    "maid.scan.pick_from_list_hint":
      "Please choose a machine from the list below",
    "maid.scan.machines_free": "{count} machines free",
    "maid.scan.checking_camera": "Checking the camera...",
    "maid.scan.assigning": "Assigning the machine...",
    "maid.scan.scan_qr_on": "Scan the QR code on the {machine}",
    "maid.scan.scan_qr_hint": "you want to use",

    "maid.history.title": "Service history",
    "maid.history.search_title": "Search service history",
    "maid.history.search_placeholder":
      "Customer name, phone, queue or basket number",
    "maid.history.sort_by": "Sort by",
    "maid.history.sort_date": "Date",
    "maid.history.sort_queue": "Queue no.",
    "maid.history.sort_basket": "Basket no.",
    "maid.history.old_to_new": "Oldest → newest",
    "maid.history.new_to_old": "Newest → oldest",
    "maid.history.low_to_high": "Low → high",
    "maid.history.high_to_low": "High → low",
    "maid.history.empty": "No service history yet",
    "maid.history.not_found": "No history matched the search",
    "maid.history.back": "‹ Back to history",
    "maid.history.photo_basket": "Basket photo",
    "maid.history.photo_detergent": "Detergent photo",
    "maid.history.photo_done": "Finished photo",
    "maid.history.photo_delivery": "Hand-over photo",
    "maid.history.photo_completed": "Finished laundry photo",
    "maid.history.receipt": "Receipt",

    "maid.timer.not_started": "{label}: not started",
    "maid.timer.done": "Done!",
    "maid.timer.started_at": "Started:",
    "maid.timer.minutes": "{minutes} min",

    "maid.services": "Services used",
    "maid.discounts": "Discounts",
    "maid.service_fee": "Drop&Go service fee",
    "maid.discount.service": "Drop&Go service discount",
    "maid.discount.status_gold": "Gold status discount",
    "maid.discount.points": "Points discount",
    "maid.discount.coupon": "Coupon discount",
    "maid.payment": "Amount paid",

    "maid.tab.new_basket": "New basket",
    "maid.tab.preparing": "Preparing",
    "maid.tab.working": "Working",
    "maid.tab.completed": "Done",
    "maid.tab.pickup": "Hand over",

    "maid.print.receipt": "Print receipt",
    "maid.print.basket_slip": "Print basket slip",
    "maid.print.all": "Print both",
    "maid.print.hint_all": "Check both sheets, then press “Print both” again to print",
    "maid.print.hint_basket": "Check the basket slip, then press “Print basket slip” again to print",
    "maid.print.hint_customer": "Check the receipt, then press “Print receipt” again to print",

  },

  my: {
    "maid.title": "ဝန်ထမ်း",
    "maid.history": "မှတ်တမ်း",
    "maid.branch": "ဆိုင်ခွဲ",
    "maid.branch_code": "ဆိုင်ခွဲကုဒ် {code}",
    "maid.login_subtitle": "ဝန်ထမ်းအလုပ်စီမံခန့်ခွဲမှုစနစ်",
    "maid.login_submit": "ဝင်ရောက်ရန်",

    "maid.stage.drop": "အဝတ်ချ",
    "maid.stage.wash": "လျှော်",
    "maid.stage.dry": "အခြောက်ခံ",
    "maid.stage.finish": "ပြီးဆုံး",
    "maid.stage.pickup": "အဝတ်ပေးအပ်",

    "maid.queue": "တန်းစီနံပါတ်",
    "maid.basket_queue": "တောင်းနံပါတ်",
    "maid.basket_queue_laundry": "အဝတ်တောင်းနံပါတ်",
    "maid.pickup_queue": "အဝတ်ယူနံပါတ်",
    "maid.machine_number": "စက်နံပါတ်",
    "maid.machine_short": "စက်",
    "maid.customer": "ဖောက်သည်",
    "maid.phone": "ဖုန်းနံပါတ်",
    "maid.credit_total": "စုစုပေါင်းငွေ",
    "maid.credit_used": "သုံးပြီး",
    "maid.credit_left": "ကျန်ငွေ",
    "maid.amount_total": "စုစုပေါင်းငွေပမာဏ",
    "maid.amount_used": "သုံးပြီးငွေ",
    "maid.amount_left": "ကျန်ရှိငွေ",
    "maid.all_items": "စာရင်းအားလုံး",
    "maid.note": "*မှတ်ချက်",
    "maid.notes_label": "မှတ်ချက် -",
    "maid.order_detail": "အော်ဒါအသေးစိတ်",
    "maid.grand_total": "စုစုပေါင်း",
    "maid.no_orders": "ယခုအချိန်တွင် အော်ဒါမရှိပါ",
    "maid.new_basket_alert": "တောင်းအသစ်ရောက်လာသည်!",
    "maid.view": "ကြည့်ရန်",
    "maid.uploading_photo": "ဓာတ်ပုံတင်နေသည်...",
    "maid.proof": "အထောက်အထား",
    "maid.close_detail": "အသေးစိတ်ပိတ်ရန်",

    "maid.service.wash": "လျှော် {size}",
    "maid.service.dry": "အခြောက်ခံ {size}",
    "maid.service.washer": "အဝတ်လျှော်စက် {size}",
    "maid.service.dryer": "အခြောက်ခံစက် {size}",
    "maid.service.detergent": "ဆပ်ပြာရည် {count}",
    "maid.service.softener": "အဝတ်ပျော့ဆေး {count}",
    "maid.service.extra_dry": "အခြောက်ခံအချိန်ထပ်ထည့် {minutes} မိနစ်",
    "maid.water.cold": "ရေအေး",
    "maid.water.warm": "ရေနွေးလေး",
    "maid.water.hot": "ရေပူ",

    "maid.btn.wash": "လျှော်",
    "maid.btn.dry": "အခြောက်ခံ",
    "maid.btn.backup": "အရန်စက်",
    "maid.btn.backup_in": "အရန်စက် {seconds} စက္ကန့်အတွင်း",
    "maid.btn.confirm": "အတည်ပြု",
    "maid.btn.deliver": "အဝတ်ပေးအပ်",
    "maid.btn.receive": "အဝတ်လက်ခံ",
    "maid.btn.close": "ပိတ်ရန်",
    "maid.btn.cancel": "ပယ်ဖျက်",
    "maid.btn.ok": "အိုကေ",
    "maid.btn.yes": "ဟုတ်ကဲ့",
    "maid.btn.no": "မဟုတ်ပါ",
    "maid.btn.save_order": "စာရင်းသိမ်းရန်",
    "maid.btn.saving": "သိမ်းနေသည်...",
    "maid.btn.processing": "ဆောင်ရွက်နေသည်...",
    "maid.btn.printing": "ပရင့်ထုတ်နေသည်...",
    "maid.btn.start_work": "အလုပ်စတင်ရန်",
    "maid.btn.finish": "ပြီးဆုံး",
    "maid.btn.ready_to_deliver": "ပေးအပ်ရန်အဆင်သင့်",
    "maid.btn.detergent_photo": "ဆပ်ပြာရည်ဓာတ်ပုံရိုက်",
    "maid.btn.detergent_photo_again": "ဆပ်ပြာရည်ဓာတ်ပုံပြန်ရိုက်",
    "maid.btn.basket_photo": "တောင်းဓာတ်ပုံရိုက်",
    "maid.btn.basket_photo_again": "တောင်းဓာတ်ပုံပြန်ရိုက်",
    "maid.btn.scan_washer": "အဝတ်လျှော်စက် QR ဖတ်ရန်",
    "maid.btn.scan_dryer": "အခြောက်ခံစက် QR ဖတ်ရန်",
    "maid.btn.back_home": "ပင်မစာမျက်နှာသို့",
    "maid.btn.print_new_slip": "စာရင်းအသစ်ပရင့်ထုတ်",
    "maid.btn.print_new_receipt": "ငွေလက်ခံဖြတ်ပိုင်းအသစ်ပရင့်ထုတ်",

    "maid.toast.confirmed_ready": "အတည်ပြုပြီး၊ ပေးအပ်ရန်အဆင်သင့်",
    "maid.toast.delivered": "အဝတ်ပေးအပ်ပြီး",
    "maid.toast.detergent_saved": "ဆပ်ပြာရည်ဓာတ်ပုံသိမ်းပြီး",
    "maid.toast.detergent_save_failed": "ဆပ်ပြာရည်ဓာတ်ပုံမသိမ်းနိုင်ပါ",
    "maid.toast.order_saved": "စာရင်းသိမ်းပြီး",
    "maid.toast.order_save_failed": "စာရင်းမသိမ်းနိုင်ပါ",
    "maid.toast.receive_failed": "အဝတ်လက်ခံ၍မရပါ",
    "maid.toast.basket_queue_required": "တောင်းနံပါတ်ဖြည့်ပါ",
    "maid.toast.basket_queue_before_print":
      "မပရင့်ထုတ်မီ တောင်းနံပါတ်ဖြည့်ပါ",
    "maid.toast.basket_queue_save_failed": "တောင်းနံပါတ်မသိမ်းနိုင်ပါ",
    "maid.toast.no_printer": "ဘလူးတုသ်ပရင်တာမတွေ့ပါ",
    "maid.toast.pickup_queue_required":
      "အဝတ်မလက်ခံမီ အဝတ်ယူနံပါတ်ဖြည့်ပါ",
    "maid.toast.basket_photo_required":
      "အဝတ်မလက်ခံမီ တောင်းဓာတ်ပုံရိုက်ပါ",
    "maid.toast.photo_required": "ဓာတ်ပုံရိုက်ပါ သို့မဟုတ် ရွေးချယ်ပါ",
    "maid.toast.error": "အမှားဖြစ်ပွားခဲ့သည်",
    "maid.toast.error_retry": "အမှားဖြစ်ပွားခဲ့သည်၊ ထပ်မံကြိုးစားပါ",
    "maid.toast.error_retry_long": "အမှားဖြစ်ပွားခဲ့သည်၊ ထပ်မံကြိုးစားပါ",
    "maid.no_order_found": "အော်ဒါအချက်အလက်မတွေ့ပါ",
    "maid.basket_photo_hint": "အဝတ်မလက်ခံမီ တောင်းဓာတ်ပုံရိုက်ပါ",
    "maid.cancel_title": "ပယ်ဖျက်ရန်အတည်ပြုပါ",
    "maid.cancel_order_question": "ဤအော်ဒါကို ပယ်ဖျက်မှာလား?",
    "maid.cancel_job_question": "ဤအလုပ်လက်ခံမှုကို ပယ်ဖျက်မှာလား?",

    "maid.photo.completed_title": "ပြီးဆုံးသောအဝတ်များကို ဓာတ်ပုံရိုက်ပါ",
    "maid.photo.basket_title": "တောင်းကို ဓာတ်ပုံရိုက်ပါ",
    "maid.photo.detergent_title": "ဆပ်ပြာရည်သုံးစွဲမှု ဓာတ်ပုံရိုက်ပါ",
    "maid.photo.retake": "ပြန်ရိုက်",
    "maid.photo.camera": "ကင်မရာ",
    "maid.photo.gallery": "ဓာတ်ပုံပြခန်း",

    "maid.scan.washer": "အဝတ်လျှော်စက်",
    "maid.scan.dryer": "အခြောက်ခံစက်",
    "maid.scan.allow_camera": "ကင်မရာသုံးခွင့်ပေးပါ",
    "maid.scan.invalid_qr": "QR ကုဒ်မမှန်ကန်ပါ",
    "maid.scan.machine_busy":
      "ဤ{machine}သည် အလုပ်ရှုပ်နေသည် သို့မဟုတ် အမျိုးအစားမကိုက်ညီပါ",
    "maid.scan.wrong_size": "ဤအော်ဒါအတွက် {size} kg. {machine} လိုအပ်သည်",
    "maid.scan.start_failed": "စက်ကိုအမိန့်မပေးနိုင်ပါ၊ ထပ်မံကြိုးစားပါ",
    "maid.scan.assign_failed": "စက်သတ်မှတ်၍မရပါ",
    "maid.scan.assigned_washer": "အဝတ်လျှော်စက် #{number} သတ်မှတ်ပြီး",
    "maid.scan.assigned_dryer": "အခြောက်ခံစက် #{number} သတ်မှတ်ပြီး",
    "maid.scan.no_machine_free": "အားလပ်သောစက်မရှိပါ",
    "maid.scan.camera_failed": "ကင်မရာမဖွင့်နိုင်ပါ",
    "maid.scan.pick_free_machine": "အားလပ်သော{machine}{size}ကိုရွေးပါ",
    "maid.scan.none_free": "ယခုအချိန်တွင် အားလပ်သော{machine}{size}မရှိပါ",
    "maid.scan.refresh": "ပြန်လည်စတင်",
    "maid.scan.pick_from_list": "စာရင်းမှစက်ရွေးရန်",
    "maid.scan.pick_from_list_hint": "အောက်ပါစာရင်းမှ စက်တစ်လုံးရွေးပါ",
    "maid.scan.machines_free": "အားလပ်သောစက် {count} လုံး",
    "maid.scan.checking_camera": "ကင်မရာစစ်ဆေးနေသည်...",
    "maid.scan.assigning": "စက်သတ်မှတ်နေသည်...",
    "maid.scan.scan_qr_on": "{machine}ပေါ်ရှိ QR ကုဒ်ကိုဖတ်ပါ",
    "maid.scan.scan_qr_hint": "အသုံးပြုလိုသော",

    "maid.history.title": "ဝန်ဆောင်မှုမှတ်တမ်း",
    "maid.history.search_title": "မှတ်တမ်းရှာဖွေရန်",
    "maid.history.search_placeholder":
      "ဖောက်သည်အမည်၊ ဖုန်း၊ တန်းစီ သို့မဟုတ် တောင်းနံပါတ်",
    "maid.history.sort_by": "စီစဉ်ရန်",
    "maid.history.sort_date": "ရက်စွဲ",
    "maid.history.sort_queue": "တန်းစီနံပါတ်",
    "maid.history.sort_basket": "တောင်းနံပါတ်",
    "maid.history.old_to_new": "အဟောင်း → အသစ်",
    "maid.history.new_to_old": "အသစ် → အဟောင်း",
    "maid.history.low_to_high": "နည်း → များ",
    "maid.history.high_to_low": "များ → နည်း",
    "maid.history.empty": "မှတ်တမ်းမရှိသေးပါ",
    "maid.history.not_found": "ရှာဖွေမှုနှင့်ကိုက်ညီသောမှတ်တမ်းမတွေ့ပါ",
    "maid.history.back": "‹ မှတ်တမ်းသို့ပြန်",
    "maid.history.photo_basket": "တောင်းဓာတ်ပုံ",
    "maid.history.photo_detergent": "ဆပ်ပြာရည်ဓာတ်ပုံ",
    "maid.history.photo_done": "ပြီးဆုံးဓာတ်ပုံ",
    "maid.history.photo_delivery": "ပေးအပ်ဓာတ်ပုံ",
    "maid.history.photo_completed": "ပြီးဆုံးသောအဝတ်ဓာတ်ပုံ",
    "maid.history.receipt": "ငွေလက်ခံဖြတ်ပိုင်း",

    "maid.timer.not_started": "{label} - မစတင်ရသေးပါ",
    "maid.timer.done": "ပြီးပါပြီ!",
    "maid.timer.started_at": "စတင်ချိန် -",
    "maid.timer.minutes": "{minutes} မိနစ်",

    "maid.services": "အသုံးပြုသောဝန်ဆောင်မှု",
    "maid.discounts": "လျှော့ဈေး",
    "maid.service_fee": "Drop&Go ဝန်ဆောင်ခ",
    "maid.discount.service": "Drop&Go ဝန်ဆောင်ခလျှော့ဈေး",
    "maid.discount.status_gold": "Gold အဆင့်လျှော့ဈေး",
    "maid.discount.points": "အမှတ်လျှော့ဈေး",
    "maid.discount.coupon": "ကူပွန်လျှော့ဈေး",
    "maid.payment": "ပေးချေငွေ",

    "maid.tab.new_basket": "တောင်းအသစ်",
    "maid.tab.preparing": "ပြင်ဆင်နေ",
    "maid.tab.working": "ဆောင်ရွက်နေ",
    "maid.tab.completed": "ပြီးဆုံး",
    "maid.tab.pickup": "အဝတ်ပေးအပ်",

    "maid.print.receipt": "ငွေလက်ခံဖြတ်ပိုင်းပရင့်ထုတ်",
    "maid.print.basket_slip": "တောင်းကပ်စာရွက်ပရင့်ထုတ်",
    "maid.print.all": "နှစ်မျိုးလုံးပရင့်ထုတ်",
    "maid.print.hint_all": "စာရွက်နှစ်မျိုးလုံးစစ်ပြီး “နှစ်မျိုးလုံးပရင့်ထုတ်” ကိုထပ်နှိပ်ပါ",
    "maid.print.hint_basket": "တောင်းကပ်စာရွက်ကိုစစ်ပြီး “တောင်းကပ်စာရွက်ပရင့်ထုတ်” ကိုထပ်နှိပ်ပါ",
    "maid.print.hint_customer": "ငွေလက်ခံဖြတ်ပိုင်းကိုစစ်ပြီး “ငွေလက်ခံဖြတ်ပိုင်းပရင့်ထုတ်” ကိုထပ်နှိပ်ပါ",

  },
};

export default maidTranslations;
